import styled from 'styled-components'
import { Tooltip } from '@mui/material'
import LockRoundedIcon from '@mui/icons-material/LockRounded'
import { useTranslation } from "react-i18next"

const CaptionContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`

const CaptionItemContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
  margin-bottom: 8px;
`

const Item = ({ icon, text }) => {
  return (
    <CaptionItemContainer>
      {icon}
      <span>{text}</span>
    </CaptionItemContainer>
  )
}

const Caption = () => {
  const { t } = useTranslation('common')
  return (
    <CaptionContainer>
      <Item
        icon={
          <div
            style={{
              width: 14,
              height: 14,
              backgroundColor: '#000',
              marginRight: 8,
              marginLeft: 8,
            }}
          />
        }
        text={t('caption.alertness_level')}
      />
      <Tooltip
        title={t('caption.only_optimize')}
        placement='top'
        arrow
      >
        <span>
          <Item
            icon={<LockRoundedIcon sx={{ width: 18, height: 18 }} />}
            text={t('caption.with_optimization')}
          />
        </span>
      </Tooltip>
      <Item
        icon={
          <div
            style={{
              width: 14,
              height: 14,
              backgroundColor: '#000',
              marginRight: 8,
              marginLeft: 8,
            }}
          />
        }
        text={t('caption.alert_prediction')}
      />
      <Item
        icon={
          <div
            style={{
              width: 14,
              height: 14,
              backgroundColor: '#E27837',
              marginRight: 8,
              marginLeft: 8,
            }}
          />
        }
        text={t('caption.shift')}
      />
      <Item
        icon={
          <div
            style={{
              width: 14,
              height: 14,
              backgroundColor: '#3A6CCF',
              marginRight: 8,
              marginLeft: 8,
            }}
          />
        }
        text={t('caption.sleep')}
      />
    </CaptionContainer>
  )
}

export default Caption
